module.exports = __webpack_public_path__ + "static/media/anhu.6889b3bc.png";